// extracted by mini-css-extract-plugin
var _1 = "ProviderTableRow-moduleProviderTableRow__hMah0 TableComponent-modulerow__xPAo4";
export { _1 as "ProviderTableRow" }
